import axios from 'axios'
import GlobalStore from '@/GlobalStore';
import {JOIN_CHAT_TYPE, OPEN_CHAT_REGIONS} from "../Constants";
import ResponseCode from "../ResponseCode";
import {JOIN_CHAT_INIT_ACTION_TYPE} from "../components/modal/JoinChat";

class CommonApiCall{
    get = axios.get;
    post = axios.post;

    async showPersonalChat(opponent_idx, opponent_type, chat_type = null, refer_idx = null, init_action_type = JOIN_CHAT_INIT_ACTION_TYPE.DEFAULT, isRegistTeam){
        const parameters = {
            opponent_idx : opponent_idx,
            opponent_type : opponent_type
        };

        if(chat_type != null) parameters.chat_type = chat_type;
        if(refer_idx != null) parameters.refer_idx = refer_idx;

        const res = await this.post('/api/chat/check/personalchat', parameters);
        if(res.data.code === ResponseCode.SUCCESS){
            const chat_idx = res.data.chat_idx;
            const res2 = await this.get('/api/chat/auth', {params : {chat_idx : chat_idx}});
            if(res2.data.code === ResponseCode.SUCCESS){
                GlobalStore.addModal('JoinChat', {auth : res2.data.auth, chat : res2.data.chat, chatIdx : chat_idx, init_action_type : init_action_type,
                    user : res2.data.user, opponent_idx : opponent_idx, opponent_type : opponent_type, isRegistTeam: isRegistTeam
                });
            } else if(res2.data.code === ResponseCode.FAIL){
                GlobalStore.showAlert(res2.data.msg);
            }
        }else {
            GlobalStore.showAlert(res.data.msg);
        }
    }

    async showChattingBySoccerJoinIdx(chat_idx, complete_action = () => {}, isNoticeInit = false, closeAction = () => {}, regionInfo){
        const res = await this.get('/api/chat/auth', {params : {chat_idx : chat_idx}});
        if(res.data.code === ResponseCode.SUCCESS){
            if(res.data.chat.type == JOIN_CHAT_TYPE.SINGLE || res.data.chat.type == JOIN_CHAT_TYPE.MERCENARY_REQUEST
                || res.data.chat.type == JOIN_CHAT_TYPE.MERCENARY_PROPOSE || res.data.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH){
                GlobalStore.addModal('JoinChat', { auth: res.data.auth, chat: res.data.chat, chatIdx: chat_idx, closeAction : closeAction, user : res.data.user, openMemberTalkInfo: regionInfo});
            } else if(res.data.chat.type == JOIN_CHAT_TYPE.OPEN){
                if(!regionInfo){
                    const temp_regionInfo = OPEN_CHAT_REGIONS.find(item => item.chat_idx == chat_idx);
                    if(temp_regionInfo) regionInfo = temp_regionInfo
                }

                GlobalStore.addModal('JoinChat', { auth: res.data.auth, chat: res.data.chat, chatIdx: chat_idx, closeAction : closeAction, user : res.data.user, openMemberTalkInfo: regionInfo, is_modal_full_screen : true});
            }else if(res.data.chat.type == JOIN_CHAT_TYPE.GROUP){
                GlobalStore.addModal('JoinChat', {auth : res.data.auth, chat : res.data.chat, chatIdx : chat_idx, pTitle : res.data.chat.name,
                    completeAction : complete_action, init_refer_idx :res.data.join.idx, isNoticeInit : isNoticeInit, closeAction : closeAction, user : res.data.user, is_modal_full_screen : true});
            }
        }else if(res.data.code === ResponseCode.FAIL){
            GlobalStore.showAlert(res.data.msg);
        }
    }

    async refreshLoginInfo(){
        const res = await this.get('/api/login/info');
        GlobalStore.setLoginInfo(res.data.loginInfo);
    }

}

const commonApiCall = new CommonApiCall();

export default commonApiCall;